import React from 'react';
import aboutUsImage_avif from '../Photos/About_us.avif';
import aboutUsImage_webp from '../Photos/About_us.webp';
import aboutUsImage from '../Photos/About_us.jpg';
import './AboutUs.css';
import WhatsAppButton from '../Components/WhatsAppButton';

function AboutUsPage() {
  return (
    <main className="bg-zinc-900 text-white p-4 md:p-8 my-10">
      <div className="rounded-xl shadow-lg overflow-hidden md:flex">
        <div className="md:w-1/2">
          <picture>
            <source srcSet={aboutUsImage_avif} type="image/avif" />
            <source srcSet={aboutUsImage_webp} type="image/webp" />
          <img src={aboutUsImage} alt="Brickyard at Nigel Brick and Clay" className="h-64 w-full object-cover md:h-full"/>
          </picture>
        </div>
        <div className="md:w-1/2 p-6 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold accent-red mb-4">
            Our Legacy
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-neutral-300 mb-6">
            Over 50 Years of Quality
          </h2>
          <div className="space-y-5 text-neutral-400 leading-relaxed">
            <p>
              Welcome to Nigel Brick and Clay, your trusted partner in quality clay brick manufacturing. Established as Nigel
              Brick in 1969, our legacy spans generations of expertise and commitment to excellence. For over five decades, Nigel
              Brick & Clay has been synonymous with superior craftsmanship and reliability. Our journey began with a dream
              to deliver unmatched quality to our customers, and today, we continue to uphold that tradition with pride.
            </p>
            <p>
              Brick and Clay's team brings fresh perspectives and a passion for innovation. 
              Under their leadership, Nigel Brick & Clay continues to thrive as a beacon of excellence in the clay brick manufacturing industry.
            </p>
            <p className="font-medium text-neutral-300">
              At Nigel Brick & Clay, we specialize in manufacturing clay stock bricks and clay Maxi stock bricks that meet the
              highest standards of durability and performance. Our factory has a production capacity of around 9 million bricks
              per month which produces products that are methodically crafted using premium-grade clay and innovative
              manufacturing techniques to ensure consistency, longevity and sustainability.
            </p>
          </div>
        </div>
      </div>
      <WhatsAppButton />
    </main>
  );
}

export default AboutUsPage;